module.exports = __webpack_public_path__ + "media/images/create_event_league_icon-4cf0f47c.svg";